import { ChannelType, Contact, DeliveryStatus, MessageCategory } from '../../models/conversations';
import { Tooltip } from '@mui/material';
import { useSelector } from "react-redux";
import { DeliveredIcon, DownloadMediaIcon, ForwardMessageIcon, HistoryCheckIcon, HistoryExclamatoryIcon, HistoryTimerIcon, MessageSeenIcon, PriorityIcon, StatusIcon, SuggestedRepliesIcon, SystemAssaignIcon, UserAssaignIcon, UserAvatorIcon } from '../../icon';
import { MediaModel } from '../../models/templates.models';
import { ChannelUserModel, UserModel } from '../../models/users.model';
import * as selector from '../../selectors/selectors';
import { FileService } from '../../services/FileService';
import { UtilityService } from '../../services/UtilityService';
import { AutomationRulesLabel, Tags } from '../shared/constants';
import MediaComponent from "../shared/media/media.component";
import Mention from '../shared/mentions';
import MediaContainer from '../shared/media/media.container';
import { ChannelDeliveryStatus } from '../../models/channels/channels.model';
import { useRef } from 'react';
import { TicketHighIcon, TicketLowIcon, TicketMediumIcon } from "../../icon";
import { ChannelUserService } from '../../services/ChannelUserService';

interface IProps {
    MessageData: any;
    OpenForwardMessage: (media: MediaModel, msg: string) => void;
    ChannelType?: number;
    UserName?: string;
    ProfilePicLink?: string
    TemplateMessage?: any;
    IsWidget?: boolean;
    OpenSuggestedReplies?: (message: string, messageId: string) => void;
    selectedMessageForSuggestion?: string;
}

const DisplayConversation = (props: IProps) => {
    const wrapperRef = useRef<HTMLDivElement>(null);

    const { IsOutbound, Message, Media, FromPhoneNumber, MessageDateTime, GroupChat, SenderID } = props.MessageData;
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const AllUsers: UserModel[] = useSelector(selector.allUsers);
    const Contacts: Contact[] = useSelector(selector.contacts);
    const CurrentUser: ChannelUserModel = ChannelUserService.getCurrentUserFromLocalStorage();
    const ChannelUsers: ChannelUserModel[] = useSelector(selector.ChannelUsers)



    const getUserName = (senderId: string) => {
        if (props.MessageData?.MessageCategory === MessageCategory.Automated_Message) {
            return AutomationRulesLabel.AUTOMATED_REPLY
        }
        else if (props.MessageData?.MessageCategory === MessageCategory.Welcome_Message) {
            return "Greeting message"
        }
        else if ((senderId || props.MessageData?.MessageCategory === MessageCategory.Basic_Message)) {
            let data = ChannelUsers.find((x) => x.ID === senderId);
            return !!data && UtilityService.trimMessage(data.FullName, 20)
        }
    }

    const getGroupChatUserName = (number: string) => {
        var data = Contacts.find((x) => x.PhoneNumber === number);
        if (!!data) {
            let name = data?.Name;
            return UtilityService.trimMessage(name, 17)
        }
        else if (data === undefined) {
            return UtilityService.maskPhoneNumberOnLength(number)
        }
    }

    const handleUrlRoute = (url: string, buttonName: string) => {
        if (url.length && buttonName.length) {
            window.open(url, "_blank")
        }
    }

    return (
        <div className={``}>
            {
                props.MessageData.MessageType === "TICKET" ?
                    < div className='w-p-96 mx-auto d-flex justify-center align-center my-2 br-1 min-h-2 color-con-hist-msg-date h5-medium'>
                        <div className='d-flex justify-center align-start min-h-2 min-w-2 mr-1'>{props.MessageData.Message.includes("Assigned") ?
                            <UserAssaignIcon className='' width={12} height={12} /> :
                            props.MessageData.Message.includes("Status") ?
                                <StatusIcon className='' width={12} height={12} /> :
                                props.MessageData.Message.includes("Priority") &&
                                <PriorityIcon className='' width={12} height={12} />
                        }</div>
                        <div className='d-flex justify-center align-start min-h-2'>{(props.MessageData.Message as string).slice(6, props.MessageData.Message.indexOf("to") + 2)}&nbsp;</div>
                        {props.MessageData.Message.includes("Assigned") && <div className='d-flex justify-center align-start h-p-100'>
                            {(props.MessageData.Message as string).slice(props.MessageData.Message.indexOf("to") + 2, props.MessageData.Message.indexOf("by")).trim() === CurrentUser.FullName.trim() ? "You" : (props.MessageData.Message as string).slice(props.MessageData.Message.indexOf("to") + 2, props.MessageData.Message.indexOf("by"))}
                        </div>
                        }
                        {props.MessageData.Message.includes("Status") && <div className={`min-h-2 ticketing-${props.MessageData.Message.includes("Open") ? "open" : props.MessageData.Message.includes("Closed") ? "closed" : props.MessageData.Message.includes("Followup") && "following"} d-flex justify-center  align-center h6-medium`}>
                            {props.MessageData.Message.includes("Open") ? "Open" : props.MessageData.Message.includes("Followup") ? "Following" : props.MessageData.Message.includes("Closed") && "Closed"}
                        </div>
                        }
                        {props.MessageData.Message.includes("High") ?
                            <>
                                <div className='d-flex align-start h-p-100 min-w-2 justify-center'>
                                    <TicketHighIcon width={12} height={12} />
                                </div>
                                <div>&nbsp;High</div>
                            </>

                            : props.MessageData.Message.includes("Low") ?
                                <>
                                    <div className='d-flex align-start h-p-100 min-w-2 justify-center'>
                                        <TicketLowIcon width={12} height={12} />
                                    </div>
                                    <div>&nbsp;Low</div>
                                </>

                                :
                                props.MessageData.Message.includes("Medium") &&
                                <>
                                    <div className='d-flex align-start h-p-100 min-w-2 justify-center'>
                                        <TicketMediumIcon width={12} height={12} />
                                    </div>
                                    <div>&nbsp;Medium</div>
                                </>

                        }
                        <div className='h-p-100 d-flex justify-center align-start'>
                            &nbsp;by&nbsp;
                        </div>
                        <div className='h-p-100 d-flex justify-center align-start'>
                            {(props.MessageData.Message as string).slice(props.MessageData.Message.indexOf("by") + 2).trim() === CurrentUser.FullName.trim() ? "You" : (props.MessageData.Message as string).slice(props.MessageData.Message.indexOf("by") + 2)}
                        </div>
                    </div>
                    :
                    <div className='d-flex align-end'>
                        <div className={`d-flex w-p-100 open-more-options align-center ${IsOutbound ? "justify-flex-end" : ""}`}>
                            <div className={`p-1 my-1 h5-regular ${props.MessageData.MessageType === "template" ? "" : IsOutbound ? "outboundmsg mr-1" : props.selectedMessageForSuggestion === props.MessageData.ID ? "replySuggestedMessage" : "inboundmsg"} ${(props.IsWidget) ? "max-w-30" : ""}`}>
                                <div className={`color-con-hist-msg-date footnote ${IsOutbound ? "  d-flex justify-between" : ""}`}>
                                    <span className={`${IsOutbound ? "mr-1" : ""}`}>{IsOutbound ? getUserName(SenderID || props.MessageData?.SenderID) : getGroupChatUserName(FromPhoneNumber)}</span>
                                    <span style={{ marginLeft: props.MessageData.GroupChat || props.MessageData.GroupChatId ? "10px" : "" }}>{UtilityService.convertToTimeFormat(MessageDateTime || props.MessageData.CreatedAt.replace(" +0000 UTC", "Z"))}</span>
                                </div>
                                {!!props.MessageData.MessageType ?
                                    <div>
                                        {
                                            props.MessageData.MessageType === "template" ?
                                                <div className={`w-25 p-relative mb-1`}>
                                                    {(props.TemplateMessage?.template_type === "button" ?
                                                        <div >
                                                            <div className="h-5 d-flex justify-center align-center bg-color-channel-button-template-header-background brt-1 channel-template-preview-box-shadow h3-medium">
                                                                {props.TemplateMessage.text}
                                                            </div>
                                                            {props?.TemplateMessage?.buttons?.map(x =>
                                                                <>
                                                                    <div className="h-p-20 d-flex justify-center align-center bg-color-secondary channel-template-preview-box-shadow color-template-link c-pointer h4-regular p-1"
                                                                        onClick={() => handleUrlRoute(x.url, x.title)}
                                                                    >
                                                                        {x.title}
                                                                    </div>
                                                                    <div className={"bb-primary-background-pink-4 mx-auto"}></div>
                                                                </>
                                                            )
                                                            }
                                                        </div>
                                                        : props.TemplateMessage?.template_type === "media" &&
                                                        <div className="d-flex flex-direction">
                                                            <div className="bg-color-secondary brt-1 channel-template-preview-box-shadow d-flex justify-center align-center p-relative">
                                                                {<MediaContainer Mediatype={props.TemplateMessage?.elements[0]?.media_type} Value={props.TemplateMessage.elements[0]?.url} />}
                                                            </div>
                                                            <div className={"bb-primary-background-pink-4 mx-auto"}></div>
                                                            <div className="brb-1 w-p-100 h-p-16 d-flex justify-center align-center bg-color-secondary channel-template-preview-box-shadow color-template-link h4-regular c-pointer"
                                                                onClick={() => handleUrlRoute(props.TemplateMessage?.elements[0]?.buttons[0]?.url, props.TemplateMessage?.elements[0]?.buttons[0]?.title)}
                                                            >
                                                                {props.TemplateMessage?.elements[0]?.buttons[0]?.title}
                                                            </div>
                                                        </div>
                                                    )
                                                    }
                                                </div>
                                                :

                                                <div ref={wrapperRef} >
                                                    <MediaContainer Mediatype={props.MessageData.MessageType} Value={props.MessageData.Message} />
                                                </div>
                                        }
                                    </div>
                                    :
                                    Media ?
                                        <div>
                                            <MediaComponent Media={Media} SenderName={IsOutbound ? getUserName(SenderID) : getGroupChatUserName(FromPhoneNumber)} />
                                            <Mention IsGroupChat={!!GroupChat?.ID} body={Message || props.MessageData.Message} tags={Tags} emoji={''} openTags={false} tagTarget={undefined} onChange={() => { }} onKeyDown={() => { }} closeTags={() => { }} maxLength={Message?.length} id={''} placeholder={''} readOnly={true} IsOutbound={IsOutbound} IsLinkAllowed={true} />
                                        </div>
                                        :
                                        // <DisplayMessageState message={Message} />
                                        <Mention IsGroupChat={!!GroupChat?.ID} body={Message} tags={Tags} emoji={''} openTags={false} tagTarget={undefined} onChange={() => { }} onKeyDown={() => { }} closeTags={() => { }} maxLength={Message?.length} id={''} placeholder={''} readOnly={true} IsOutbound={IsOutbound} IsLinkAllowed={true} />
                                }
                            </div>
                            {/* {!IsOutbound &&
                                <div className='d-flex display-more-options'>
                                    <Tooltip title={"Suggested Replies"} placement="top">
                                        <SuggestedRepliesIcon className="br-50 pl-1 w-3 h-3" onClick={() => { props.OpenSuggestedReplies(props.MessageData.Message, props.MessageData.ID) }} />
                                    </Tooltip>
                                </div>
                            } */}

                        </div>
                        {(IsOutbound) &&
                            <div>
                                {props.MessageData.DeliveryStatus === ChannelDeliveryStatus.SENDING ?
                                    <Tooltip title='Sending' placement='bottom'>
                                        <HistoryTimerIcon className="mr-1 mb-1" />
                                    </Tooltip>
                                    : props.MessageData.DeliveryStatus === ChannelDeliveryStatus.SENT ?
                                        <Tooltip title='Sent' placement='bottom'>
                                            <HistoryCheckIcon className="mr-1 mb-1" />
                                        </Tooltip>
                                        : props.MessageData.DeliveryStatus === ChannelDeliveryStatus.SENT_FAILED ?
                                            <Tooltip title='Failed' placement='bottom'>
                                                <HistoryExclamatoryIcon className="mr-1 mb-1" />
                                            </Tooltip>
                                            : props.MessageData.DeliveryStatus === ChannelDeliveryStatus.DELIVERED ?
                                                <Tooltip title='Delivered' placement='bottom'>
                                                    <DeliveredIcon className="mr-1 mb-1" />
                                                </Tooltip>
                                                : props.MessageData.DeliveryStatus === ChannelDeliveryStatus.READ ?
                                                    <Tooltip title={`Seen by ${props.UserName} at ${UtilityService.convertToDateTimeFormat(props.MessageData?.ReadAt.replace(" +0000 UTC", "Z"))}`} placement='bottom'>
                                                        <MessageSeenIcon className="mr-1 mb-1" />
                                                    </Tooltip>
                                                    : <></>
                                }
                            </div>
                        }
                    </div>
            }
        </div >
    )
}

export default DisplayConversation;